import React, { useEffect, useState } from "react";
import "../styles/HotelBoard.css";
import { useGame } from "../GameContext";
import { preloadBoardAssets } from "./assets/preloadBoardAssets";
import MESSAGES from "./hooks/message";
import {
  GameStyleType,
  Column,
  Answer,
  StatusErrorMap,
  SelectedRoom,
} from "./types/types";
import RenderPlatform from "./hooks/RenderPlatform";
import { CreateRandomBoard, createEmptyBoard } from "./hooks/CreateRandomBoard";
import RenderButton from "./hooks/RenderButton";
import { prepareBoardForGameStyle } from "./hooks/prepareBoardForGameStyle";

const Board: React.FC<GameStyleType> = ({ GameStyle, Person }) => {
  const { isGameStarted, setMessage, setRoundState, round, setIsTimerRunning,roundState } =
    useGame();
  const CHAR_COUNT = Person;

  const MAX_ROUNDS = 3;

  const [isAssetsReady, setIsAssetsReady] = useState(false);
  const [UIcolumns, setUIcolumns] = useState<Column[]>(
    prepareBoardForGameStyle(createEmptyBoard(), GameStyle),
  ); // состояние для отображения комнат на платформе
  const [activeCharacters, setActiveCharacters] = useState<number[]>([]); // id активных персонажей
  const [correctPositions, setCorrectPositions] = useState<Answer[]>([]); // правильные позиции персонажей
  const [answers, setAnswers] = useState<Answer[]>([]); // состояние для хранения ответов пользователя
  const [statusError, setStatusError] = useState<StatusErrorMap>({}); // состояние для хранения статусов ошибок в ответах пользователя
  const [currentTask, setCurrentTask] = useState<number>(1); // индекс текущего задания для отображения его в кнопках проверки
  const [selectedRoom, setSelectedRoom] = useState<SelectedRoom | null>(null); // состояние для хранения выбранной пользователем комнаты режима adress
  const [selectedErrorRoom, setSelectedErrorRoom] = useState<SelectedRoom | null>(null);// состояние для хранения ошибочной команты пользователем
  const startRound = () => {
    const { board, correct, selectedIds } = CreateRandomBoard(CHAR_COUNT);
    const preparedBoard = prepareBoardForGameStyle(board, GameStyle);

    setUIcolumns(preparedBoard);
    setCorrectPositions(correct);
    setActiveCharacters(selectedIds);
    setCurrentTask(1);
    setSelectedRoom(null);
    setSelectedErrorRoom(null);
    setRoundState("playing");
    setIsTimerRunning(true);
    setStatusError({});
    setAnswers(
      selectedIds.map((id) => ({
        idCharecter: id,
        input: "",
        position: null,
      })),
    );
  };

  useEffect(() => {
  const load = async () => {
    await preloadBoardAssets();
    setIsAssetsReady(true);
  };

  load();
}, []);

  useEffect(() => {
    if (!isGameStarted) return;
    setMessage(
      MESSAGES.roundStart(round) +
        (GameStyle === "orbital"
          ? MESSAGES.orbitalInstruction
          : MESSAGES.adressInstruction),
    );

    startRound();
  }, [isGameStarted, round]);

  return (
    <div className="hotel-Board">
      <div className="hotel-Scene">
        {!isAssetsReady ? (
        <div className="hotel-board-loading">
          <div className="hotel-loading-text">Загрузка...</div>
        </div>
      ) :(<>  <img
          className="hotel-BackgroundImg"
          src="/img/stevehotel/fon.svg"
          alt="Фон"
        ></img>
        <RenderPlatform
          UIcolumns={UIcolumns}
          gameStyle={GameStyle}
          isGameStarted={isGameStarted}
          roundState = {roundState}
          selectedRoom={selectedRoom}
          selectedErrorRoom={selectedErrorRoom}
          setSelectedErrorRoom = {setSelectedErrorRoom}
          setSelectedRoom={setSelectedRoom}
        />
      </>)}
      </div>
      <RenderButton
        gameStyle={GameStyle}
        answers={answers} // ответы пользователя для каждого персонажа
        activeCharacters={activeCharacters} // id активных персонажей для отображения их в кнопках проверки
        correctPositions={correctPositions} // правильные позиции персонажей для проверки ответов
        maxRounds={MAX_ROUNDS} // максимальное количество раундов
        statusError={statusError} // статусы для отображения ошибок в ответах
        currentTask={currentTask} // индекс текущего задания для отображения его в кнопках проверки
        setCurrentTaskIndex={setCurrentTask} // функция для изменения индекса текущего задания
        selectedRoom={selectedRoom}
        setSelectedRoom={setSelectedRoom}
        setSelectedErrorRoom = {setSelectedErrorRoom}
        setAnswers={setAnswers}
        setStatusError={setStatusError}
        setUIcolumns={setUIcolumns}
      />
    </div>
  );
};

export default Board;
